import { ReactFlowProvider } from 'reactflow';
import React, { useContext, useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Licencas from './pages/Licencas';
import LicencaNova from './pages/LicencaNova';
import Usuarios from './pages/Usuarios';
import UsuariosNovo from './pages/UsuariosNovo';
import Login from './pages/Login';
import NavBar from './components/NavBar';
import PrivateRoute from './components/PrivateRoute';
import FlowEditor from './flow/FlowEditor';
import FlowEditorGpt from './flow/FlowEditorGpt';
import TokenCrud from './tokens/TokenCrud';
import WhiteLabel from './pages/WhiteLabel';
import ListarCobrancasPix from './pages/ListarCobrancasPix';
import ListarKitBlindagemHistorico from './pages/ListarKitBlindagemHistorico';

import AcessosLog from './pages/AcessosLog';
import AtivacoesExcluidasLogAgg from './pages/AtivacoesExcluidasLogAgg';

import { Box } from '@mui/material';
import { AuthContext } from './context/AuthContext';

import KanbanClientes from './pages/KanbanClientes';

import TrocarSenha from './pages/TrocarSenha';
import EsqueciSenha from './pages/EsqueciSenha'; // <<< NOVO

function App() {
  const { userTipo } = useContext(AuthContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => setIsAuthenticated(!!userTipo), [userTipo]);

  const isLicenca = userTipo === 'licenca';

  // Esconde NavBar quando estiver em QUALQUER editor de flow
  const isFlowEditor = location.pathname.startsWith('/floweditor');

  // Decide o destino da raiz:
  // - ?editor=gpt|classic tem prioridade (ex: /?editor=gpt&chave=XYZ)
  // - senão, vai para o clássico por padrão (mantendo a mesma query string)
  const decideRootTarget = () => {
    if (!isLicenca) return '/licencas';
    const qs = new URLSearchParams(location.search);
    const editor = (qs.get('editor') || '').toLowerCase();
    const suffix = location.search || '';
    if (editor === 'gpt') return `/floweditor-gpt${suffix}`;
    return `/floweditor${suffix}`;
  };

  return (
    <>
      {isAuthenticated && !isFlowEditor && <NavBar />}

      <ReactFlowProvider>
        <Box sx={{ minHeight: 'calc(100vh - 64px - 40px)' }}>
          <Routes>
            {/* Raiz única que redireciona conforme regra acima */}
            <Route path="/" element={<Navigate to={decideRootTarget()} replace />} />

            {/* PÚBLICAS */}
            <Route path="/login" element={<Login />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} /> {/* NOVA */}

            {/* Dois editores coexistindo */}
            <Route path="/floweditor" element={<FlowEditor />} />
            <Route path="/floweditor-gpt" element={<FlowEditorGpt />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/licencas"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <Licencas />
                </PrivateRoute>
              }
            />
            <Route
              path="/licencas/novo"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <LicencaNova />
                </PrivateRoute>
              }
            />
            <Route
              path="/licencas/novo/:id"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <LicencaNova />
                </PrivateRoute>
              }
            />
            <Route
              path="/usuarios"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <Usuarios />
                </PrivateRoute>
              }
            />
            <Route
              path="/usuarios/novo"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <UsuariosNovo />
                </PrivateRoute>
              }
            />
            <Route
              path="/usuarios/novo/:id"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <UsuariosNovo />
                </PrivateRoute>
              }
            />
            <Route
              path="/tokens"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <TokenCrud />
                </PrivateRoute>
              }
            />
            <Route
              path="/minha-conta/trocar-senha"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor', 'licenca']}>
                  <TrocarSenha />
                </PrivateRoute>
              }
            />
            <Route
              path="/whitelabel"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <WhiteLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/listar-cobrancas-Pix"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <ListarCobrancasPix />
                </PrivateRoute>
              }
            />
            <Route
              path="/listar-kit-historico"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <ListarKitBlindagemHistorico />
                </PrivateRoute>
              }
            />

            <Route
              path="/acessos"
              element={
                <PrivateRoute allowedTypes={['admin']}>
                  <AcessosLog />
                </PrivateRoute>
              }
            />

            <Route
              path="/relatorios/excluidas"
              element={
                <PrivateRoute allowedTypes={['admin']}>
                  <AtivacoesExcluidasLogAgg />
                </PrivateRoute>
              }
            />

            <Route
              path="/kanban"
              element={
                <PrivateRoute allowedTypes={['admin', 'revendedor']}>
                  <KanbanClientes />
                </PrivateRoute>
              }
            />

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Box>
      </ReactFlowProvider>

      <Box
        mt={4}
        mb={4}
        p={1}
        textAlign="center"
        fontSize="16px"
        fontWeight="bold"
        fontFamily="'Courier New', monospace"
        color="#1976d2"
        bgcolor="#e3f2fd"
        borderRadius={1}
      >
        🤖 Sistema desenvolvido com IA (ChatGPT - OpenAI)
      </Box>
    </>
  );
}

export default App;
